import { call, put, select, takeLatest, takeLeading, delay, takeEvery } from "redux-saga/effects";
import {
  fetchResearch,
  fetchResearchFailure,
  fetchResearchInit,
  fetchResearchSuccess,
  getResearchCategory,
  getResearchCategoryFailure,
  getResearchCategorySuccess,
  requestFetchResearch,
} from "redux/reducers/research";
import { ResearchSelector } from "redux/selector/research-selector";
import { ResearchAPI } from "services/research";
import { toPagingServer } from "utils/common-util";

const CategoryAll = {
  categoryNo: -1,
  categoryName: "All",
};

function* getResearchCategorySaga() {
  try {
    const response = yield call(ResearchAPI.getResearchCategory);
    const categories = response.data.categories || [];
    categories.unshift(CategoryAll);
    yield put(getResearchCategorySuccess(categories));
  } catch (error) {
    yield put(getResearchCategoryFailure(error));
  }
}

function* requestFetchResearchSaga(action) {
  yield call(fetchResearchSaga, action);
}

const isCategoryAll = (categoryNo) => +categoryNo === +CategoryAll.categoryNo;

function* fetchResearchSaga({ payload: categoryNo }) {
  try {
    const research = (yield select(ResearchSelector.research))[categoryNo];
    if (!research.end) {
      yield put(fetchResearch(categoryNo));
      const criteries = {
        categoryNo: isCategoryAll(categoryNo) ? null : categoryNo,
        ...toPagingServer(research.paginable, true),
      };
      const response = yield call(ResearchAPI.getResearchList, criteries);
      const { news, pageIndex: current, rowPerPage: pageSize, total } = response.data;
      yield put(
        fetchResearchSuccess({
          categoryNo,
          news,
          total,
          paginable: { current, pageSize },
        })
      );
      yield delay(700); // prevent scroll event immediently call after fetched
    }
  } catch (error) {
    yield put(fetchResearchFailure({ categoryNo, ...error }));
  }
}

const saga = [
  takeLatest(getResearchCategory.type, getResearchCategorySaga),
  takeEvery(fetchResearchInit.type, requestFetchResearchSaga),
  takeLeading(requestFetchResearch.type, requestFetchResearchSaga),
];

export default saga;
